import type {
  Block,
  CarteBlancheBlock,
  ElementBlock,
  EnhHeadingBlock,
  VideoBlock,
} from '@hanzo/ui/blocks'
import { DEF_VIDEO_PROPS } from '@luxfi/data'
import ProductCTA from '@/components/product-cta'

const validatorVideo = {
  blockType: 'video',
  videoProps: DEF_VIDEO_PROPS,
  poster: 'https://cdn.lux.network/commerce/vl/product/Lux-VALIDATOR-poster.jpg',
  sources: [
    'https://cdn.lux.network/commerce/vl/product/Lux-VALIDATOR-transcode.mp4',
    'https://cdn.lux.network/commerce/vl/product/Lux-VALIDATOR-transcode.webm'
  ],
  dim: {md: {w: 656, h: 484}, lg: {w: 656, h: 484}},
  sizing: { vh: 25, mobile: {vw: 50} }
} as VideoBlock

const coinVideo = {
  blockType: 'video',
  videoProps: DEF_VIDEO_PROPS,
  poster: 'https://cdn.lux.network/commerce/cn/product/LUX-COIN-poster.jpg',
  sources: [
    'https://cdn.lux.network/commerce/cn/product/LUX-COIN-transcode.mp4',
    'https://cdn.lux.network/commerce/cn/product/LUX-COIN-transcode.webm'
  ],
    dim: {md: {w: 546, h: 540}, lg: {w: 546, h: 540}},
    sizing: { vh: 25, mobile: {vw: 50} }
} as VideoBlock

const bylines = [
  'Run a validator node on P-Chain to secure the network. Validators participate in Quasar consensus with sub-second finality across all six chains.',
  'Stake LUX on P-Chain to participate in network governance. LUX uses 6 decimals (microLUX base unit) with a 2 trillion supply cap.',
]

export default [
  {blockType: 'carte-blanche',
    specifiers: 'variant-mobile-content-left no-inner-borders big-padding-content',
    content: [
      validatorVideo,
      {blockType: 'enh-heading',
        specifiers: 'center byline-center',
        heading: {text: 'VALIDATOR', level: 2, mb: 5},
        byline: {text: bylines[0], level: 6}
      } as EnhHeadingBlock,
      {blockType: 'space', level: 0},
      {blockType: 'element',
        element: <ProductCTA learnMoreText='Learn more' learnMoreUrl='/validator' skuPath='LXM-VL' />
      } satisfies ElementBlock as Block
    ]
  } as CarteBlancheBlock,
  {blockType: 'carte-blanche',
    specifiers: 'no-inner-borders big-padding-content',
    content: [
      coinVideo,
      {blockType: 'enh-heading',
        specifiers: 'center byline-center',
        heading: {text: 'COIN', level: 2, mb: 5},
        byline: {text: bylines[1], level: 6}
      } as EnhHeadingBlock,
      {blockType: 'space', level: 0},
      {blockType: 'element',
        element: <ProductCTA learnMoreText='Learn more' learnMoreUrl='/coin' skuPath='LXM-CN' />
      } satisfies ElementBlock as Block
    ]
  } as CarteBlancheBlock,
] as Block[]
